import { useEffect, useState } from 'react';

const navLinks = [
  { label: '证据归档库', href: '#archive' },
  { label: '时间线锤', href: '#timeline' },
  { label: '文件解析站', href: '#parse' },
  { label: '对线区', href: '#discuss' },
  { label: '热度榜', href: '#rank' },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 cursor-pointer">
          <span
            className={`w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center text-lg transition-colors ${
              scrolled
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-50/15 text-background-50 backdrop-blur-sm'
            }`}
          >
            <i className="ri-plant-line" />
          </span>
          <span className="flex flex-col leading-none">
            <strong
              className={`text-base md:text-lg font-bold tracking-wide ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              瓜田黑料
            </strong>
            <em
              className={`not-italic text-[10px] md:text-[11px] tracking-[0.24em] uppercase mt-1 ${
                scrolled ? 'text-foreground-500' : 'text-background-100/80'
              }`}
            >
              Evidence Archive
            </em>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-700 hover:bg-primary-100/60'
                  : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#subscribe"
            className={`px-4 py-2 text-sm rounded-md border transition-colors cursor-pointer whitespace-nowrap ${
              scrolled
                ? 'border-primary-300 text-primary-700 hover:bg-primary-100/70'
                : 'border-background-100/50 text-background-50 hover:bg-background-50/10'
            }`}
          >
            收藏订阅
          </a>
          <a
            href="#discuss"
            className="px-4 py-2 text-sm rounded-md bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            提交线索
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer ${
            scrolled ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {menuOpen ? (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-3 text-sm rounded-md text-foreground-700 hover:bg-primary-100/60 hover:text-primary-700 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="flex flex-col sm:flex-row gap-3 mt-4">
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="flex-1 text-center px-4 py-2 text-sm rounded-md border border-primary-300 text-primary-700 cursor-pointer whitespace-nowrap"
            >
              收藏订阅
            </a>
            <a
              href="#discuss"
              onClick={() => setMenuOpen(false)}
              className="flex-1 text-center px-4 py-2 text-sm rounded-md bg-accent-500 text-background-50 cursor-pointer whitespace-nowrap"
            >
              提交线索
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}